import React from "react";
import "./Top500ListDisplay.css";
import { graphql, useLazyLoadQuery } from "react-relay";
import StatTable from "../../../../../StatTable";

const GET_LINEUPS = graphql`
  query Top500ListDisplayQuery($contestId: ID!, $playerId: ID) {
    top500SummaryForContest(contestId: $contestId, playerId: $playerId) {
      lineupId
      lineupNum
      totalLineups
      lineupScore
      numMadeCut
      salaryTot
      draftkingsUser {
        username
      }
    }
  }
`;

export default function Top500ListDisplay({ contestId, playerId }) {
  const data = useLazyLoadQuery(
    GET_LINEUPS,
    {
      contestId: contestId,
      playerId: playerId,
    },
    { fetchPolicy: "network-only" }
  );

  console.log(data);
  const tableData = React.useMemo(() => {
    return data.top500SummaryForContest.map((lineup, index) => {
      const newLineup = { ...lineup };

      newLineup.entrant = `${lineup.draftkingsUser.username} (x${lineup.totalLineups})`;
      newLineup.rank = index + 1;

      return newLineup;
    });
  }, [contestId, playerId]);

  const columns = [
    { Header: "Rank", accessor: "rank" },
    { Header: "Entrant", accessor: "entrant" },
    { Header: "Entry #", accessor: "lineupNum" },
    { Header: "Salary", accessor: "salaryTot" },
    { Header: "DK Tot", accessor: "lineupScore" },
    { Header: "Thru Cut", accessor: "numMadeCut" },
  ];

  return (
    <div>
      <StatTable
        data={tableData}
        columns={columns}
        showDKPlayerInfo={(p) => {
          console.log(p);
        }}
        paginate={true}
      />
    </div>
  );
}
